'use client';

import { useSatelliteWebLandlordApplicationHandler_inviteToApply } from '@zg-rentals/ts-satellite-client-react-query';

/**
 * Wraps the landlord invite-to-apply mutation so consumers reach satellite
 * through this module rather than the raw client (Proxit).
 */
export function useInviteToApply() {
  return useSatelliteWebLandlordApplicationHandler_inviteToApply({
    meta: {
      context: { api: 'satellite-api', details: 'inviteToApply' },
    },
  });
}
